import { action, createRequestTypes } from './base';

export const dcActionTypes = {
  GET_DC: createRequestTypes('GET_DC'),
  GET_DC_BY_ID: createRequestTypes('GET_DC_BY_ID'),
  CREATE_DC: createRequestTypes('CREATE_DC'),
  UPDATE_DC: createRequestTypes('UPDATE_DC'),
  UPDATE_STATUS_DC: createRequestTypes('UPDATE_STATUS_DC'),
  DELETE_DC: createRequestTypes('DELETE_DC'),
  UPDATE_DC_WORKFLOW_STEP: createRequestTypes('UPDATE_DC_WORKFLOW_STEP'),
  UPDATE_DELIVERY_CHALLAN_STATUS: createRequestTypes('UPDATE_DELIVERY_CHALLAN_STATUS'),
  QUICK_UPDATE_DELIVERY_CHALLAN: createRequestTypes('QUICK_UPDATE_DELIVERY_CHALLAN'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param dcId
 * @param dcEntityId
 * @param dcEntityType
 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class DCActions {
  /**
   * @param {*} orgId
   * @param {*} dcId
   * @param {*} page
   * @param tenantId
   * @param customerId
   * @param tenantSellerId
   * @param dcId
   * @param status
   * @param searchKeyword
   * @param stockTransferId
   * @param challanId
   * @param {*} limit
   * @return
   */
    getDC = (tenantId, stockTransferId, challanId, limit, page, searchKeyword, department, secondaryStatus, is_list) => action(dcActionTypes.GET_DC.REQUEST, {
      tenantId, stockTransferId, challanId, limit, page, searchKeyword, department, secondaryStatus, is_list,
    })

    /**
     *
     * @param {*} getDCLoading
     * @return
     */
     getDCLoading = (getDCLoading) => action(dcActionTypes.GET_DC.LOADING, {
       getDCLoading,
     })

     /**
      * @return
      * @param dcs
      * @param deliveryChallan
      * @param deliveryChallans
      * @param customFields
      */
     getDCSuccess = (deliveryChallans) => action(dcActionTypes.GET_DC.SUCCESS, {
       deliveryChallans,
     })

     /**
      * @param {*} tenantId
      * @param orgId
      * @param {*} dcId
      * @return
      */
     getDCById = (tenantId, dcId, callback) => action(dcActionTypes.GET_DC_BY_ID.REQUEST, {
       tenantId, dcId, callback,
     })

     /**
      *
      * @param {*} getDCByIdLoading
      * @return
      */
     getDCByIdLoading = (getDCByIdLoading) => action(dcActionTypes.GET_DC_BY_ID.LOADING, {
       getDCByIdLoading,
     })

     /**
      * @return
      * @param selectedDC
      * @param dcData
      */
      getDCByIdSuccess = (selectedDC) => action(dcActionTypes.GET_DC_BY_ID.SUCCESS, {
        selectedDC,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createDC = (payload, callback) => action(dcActionTypes.CREATE_DC.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createDCLoading
     * @return
     */
    createDCLoading = (createDCLoading) => action(dcActionTypes.CREATE_DC.LOADING, {
      createDCLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateDC = (payload, callback) => action(dcActionTypes.UPDATE_DC.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateDCLoading
      * @return
      */
     updateDCLoading = (updateDCLoading) => action(dcActionTypes.UPDATE_DC.LOADING, {
       updateDCLoading,
     })

    /**
     * @param tenantId
     * @param dcId
     * @param orgId
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    updateDCStatus = (payload, callback) => action(dcActionTypes.UPDATE_STATUS_DC.REQUEST, {
      payload, callback,
    })

    /**
     * @param updateDCStatusLoading
     * @return {{type: *}}
     */
     updateDCStatusLoading = (updateDCStatusLoading) => action(dcActionTypes.UPDATE_STATUS_DC.LOADING, {
       updateDCStatusLoading,
     })

     /**
      * @param tenantId
      * @param dcId
      * @param orgId
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
    deleteDC = (payload, callback) => action(dcActionTypes.DELETE_DC.REQUEST, {
      payload, callback,
    })

    /**
     * @param deleteDCLoading
     * @return {{type: *}}
     */
     deleteDCLoading = (deleteDCLoading) => action(dcActionTypes.DELETE_DC.LOADING, {
       deleteDCLoading,
     })
     
      /** @param updateDCWorkflowStep */
      updateDCWorkflowStep = (payload, callback) => action(dcActionTypes.UPDATE_DC_WORKFLOW_STEP.REQUEST, {
        payload, callback,
      })
      /** @param updateDCWorkflowStepLoading */
      updateDCWorkflowStepLoading = (updateDCWorkflowStepLoading) => action(dcActionTypes.UPDATE_DC_WORKFLOW_STEP.LOADING, {
        updateDCWorkflowStepLoading,
      })

      updateDeliveryChallanStatus = (payload, callback) => action(dcActionTypes.UPDATE_DELIVERY_CHALLAN_STATUS.REQUEST, {
        payload, callback,
      })
      /** @param updateDeliveryChallanStatusLoading */
      updateDeliveryChallanStatusLoading = (updateDeliveryChallanStatusLoading) => action(dcActionTypes.UPDATE_DELIVERY_CHALLAN_STATUS.LOADING, {
        updateDeliveryChallanStatusLoading,
      })

      quickUpdateDeliveryChallan = (payload, callback) => action(dcActionTypes.QUICK_UPDATE_DELIVERY_CHALLAN.REQUEST, {
        payload, callback,
      })
      /** @param quickUpdateDeliveryChallanLoading */
      quickUpdateDeliveryChallanLoading = (quickUpdateDeliveryChallanLoading) => action(dcActionTypes.QUICK_UPDATE_DELIVERY_CHALLAN.LOADING, {
        quickUpdateDeliveryChallanLoading,
      })
}

export default new DCActions();
